import React, {createContext, useContext, useEffect, useState} from 'react';
import {useQuery} from 'react-query';
import SpaceSettingApiService from '@/modules/spacesSetting/services/SpaceSettingApiService';

const ThemeContext = createContext(null);

function ThemeProvider(props) {
  const [theme, setTheme] = useState(localStorage.getItem('theme') ? JSON.parse(localStorage.getItem('theme')) : {});

  const {data} = useQuery('spacesetting', async () => {
    const {data} = await SpaceSettingApiService.getCurrentSpace();
    return data;
  });

  useEffect(() => {
    if (!data) return;
    localStorage.setItem('theme', JSON.stringify(data.metadata));
    setTheme(data.metadata);

  }, [data, setTheme]);

  return (
    <ThemeContext.Provider value={{
      theme,
      setTheme,
    }} {...props} />
  );
}

function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    return {};
  }
  const {
    theme,
    setTheme
  } = context;

  return {
    theme,
    setTheme
  };
}

export {ThemeProvider, useTheme};
